// removed by extract-text-webpack-plugin
module.exports = {"appTitle":"_-src-components-SectionList-index---appTitle---3L8M2","loader":"_-src-components-SectionList-index---loader---Nnt7C","container":"_-src-components-SectionList-index---container---3GMae","draggable":"_-src-components-SectionList-index---draggable---2CFaH","listHeader":"_-src-components-SectionList-index---listHeader---1dgWr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionList/index.css
// module id = 726
// module chunks = 1